/*----------------------
    ARTICLE SLIDERS
---------------------- */
ArticleSliders = {
    init: function () {
        if (!$(".article-sliders__gallery__slider").length) return;

        $(".article-sliders__gallery__slider").each(function () {
            var $slider = $(this);
            var key = $slider.data("key");
            var $swiper = $slider.find(".swiper-article-sliders-" + key);
            var slideCount = $swiper.find(".swiper-slide").length;

            if (slideCount < 2) return;

            new Swiper($swiper[0], {
                slidesPerView: 1,
                loop: true,
                navigation: {
                    nextEl: $slider.find(".btn--next")[0],
                    prevEl: $slider.find(".btn--prev")[0],
                },
                pagination: {
                    el: $slider.find(".swiper-pagination")[0],
                    clickable: true,
                },
            });
        });
    },
};
$(document).ready(function () {
    ArticleSliders.init();
});